/**
 * 后台-组织路由
 */
"use strict";
angular.module("organizationManagementRouter", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.state("backstage.organization", {
        url: "/organization?id",
        views: {
            "": {
                template:'<div class="view_content view_content_full organization" ui-view="main"></div>'
            },
            "main@backstage":{
                templateUrl:'./main/backstage/organizationManagement/organizationManagement_tpl.html',
                controller:'organizationManagementCtrl'
            }
        }
    });
}]);